{
  "ancillaries": {
    "bundle": {
      "showBundlesButtonText": "Show combos",
      "bundleSelectedButtonText": "Added",
      "bundleButtonUpsellText": "Add"
    },
    "seat": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, seats <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, seats <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "meals": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, meals <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, meals <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "lounge": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, lounge <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, lounge <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "wifi": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, internet <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, internet <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "bags": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, bags <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, bags <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "cabinBaggage": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, bags <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, bags <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "pet": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, pets <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, pets <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "sport": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, sports equipment <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, sports equipment <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "productList": {
      "subtitle": {
        "topPick": "Top pick for this flight:",
        "generic": "Choose from these options:",
        "added": "You've added:"
      }
    }
  },
  "upsellCard": {
    "description": {
      "genericLongHaul": "Compare the meal service, seats and entertainment in different travel classes on long-haul flights."
    },
    "modalLink": {
      "allClasses": "Travel class differences"
    }
  },
  "upsellPromotion": {
    "totalPriceInfo": "Total price for all passengers",
    "selected": "Selected",
    "changeToClassic": "Change to Classic",
    "continueWithLight": "Continue with Light",
    "continueWithSuperLight": "Continue with Superlight"
  },
  "phases": {
    "title": {
      "extrasB": "Final touches for your journey"
    },
    "sectionTitle": {
      "topPick": "Top pick for a trip like this",
      "allExtras": "All travel extras"
    }
  }
}
